export default __webpack_public_path__ + "assets/images/a062c320cd8e32d24700dff0ecc1793b.png";